
/**
 * fitty v2.3.7 - Snugly resizes text to fit its parent container
 * Copyright (c) 2023 Rik Schennink <rik@pqina.nl> (https://pqina.nl/)
 */ var $7197710c1f2e2b92$var$e = function(e) {
    if (e) {
        var t = function(e) {
            return [].slice.call(e);
        }, n = 0, i = 1, r = 2, o = 3, a = [], l = null, u = "requestAnimationFrame" in e ? function() {
            e.cancelAnimationFrame(l), l = e.requestAnimationFrame(function() {
                return s(a.filter(function(e) {
                    return e.dirty && e.active;
                }));
            });
        } : function() {}, c = function(e) {
            return function() {
                a.forEach(function(t) {
                    return t.dirty = e;
                }), u();
            };
        }, s = function(e) {
            e.filter(function(e) {
                return !e.styleComputed;
            }).forEach(function(e) {
                e.styleComputed = m(e);
            }), e.filter(y).forEach(v);
            var t = e.filter(p);
            t.forEach(d), t.forEach(function(e) {
                v(e), f(e);
            }), t.forEach(S);
        }, f = function(e) {
            return e.dirty = n;
        }, d = function(e) {
            e.availableWidth = e.element.parentNode.clientWidth, e.currentWidth = e.element.scrollWidth, e.previousFontSize = e.currentFontSize, e.currentFontSize = Math.min(Math.max(e.minSize, e.availableWidth / e.currentWidth * e.previousFontSize), e.maxSize), e.whiteSpace = e.multiLine && e.currentFontSize === e.minSize ? "normal" : "nowrap";
        }, p = function(e) {
            return e.dirty !== r || e.dirty === r && e.element.parentNode.clientWidth !== e.availableWidth;
        }, m = function(t) {
            var n = e.getComputedStyle(t.element, null);
            return t.currentFontSize = parseFloat(n.getPropertyValue("font-size")), t.display = n.getPropertyValue("display"), t.whiteSpace = n.getPropertyValue("white-space"), !0;
        }, y = function(e) {
            var t = !1;
            return !e.preStyleTestCompleted && (/inline-/.test(e.display) || (t = !0, e.display = "inline-block"), "nowrap" !== e.whiteSpace && (t = !0, e.whiteSpace = "nowrap"), e.preStyleTestCompleted = !0, t);
        }, v = function(e) {
            e.element.style.whiteSpace = e.whiteSpace, e.element.style.display = e.display, e.element.style.fontSize = e.currentFontSize + "px";
        }, S = function(e) {
            e.element.dispatchEvent(new CustomEvent("fit", {
                detail: {
                    oldValue: e.previousFontSize,
                    newValue: e.currentFontSize,
                    scaleFactor: e.currentFontSize / e.previousFontSize
                }
            }));
        }, h = function(e, t) {
            return function() {
                e.dirty = t, e.active && u();
            };
        }, w = function(e) {
            return function() {
                a = a.filter(function(t) {
                    return t.element !== e.element;
                }), e.observeMutations && e.observer.disconnect(), e.element.style.whiteSpace = e.originalStyle.whiteSpace, e.element.style.display = e.originalStyle.display, e.element.style.fontSize = e.originalStyle.fontSize;
            };
        }, b = function(e) {
            return function() {
                e.active || (e.active = !0, u());
            };
        }, z = function(e) {
            return function() {
                return e.active = !1;
            };
        }, F = function(e) {
            e.observeMutations && (e.observer = new MutationObserver(h(e, i)), e.observer.observe(e.element, e.observeMutations));
        }, g = {
            minSize: 16,
            maxSize: 512,
            multiLine: !0,
            observeMutations: "MutationObserver" in e && {
                subtree: !0,
                childList: !0,
                characterData: !0
            }
        }, W = null, E = function() {
            e.clearTimeout(W), W = e.setTimeout(c(r), x.observeWindowDelay);
        }, M = [
            "resize",
            "orientationchange"
        ];
        return Object.defineProperty(x, "observeWindow", {
            set: function(t) {
                var n = "".concat(t ? "add" : "remove", "EventListener");
                M.forEach(function(t) {
                    e[n](t, E);
                });
            }
        }), x.observeWindow = !0, x.observeWindowDelay = 100, x.fitAll = c(o), x;
    }
    function C(e, t) {
        var n = Object.assign({}, g, t), i = e.map(function(e) {
            var t = Object.assign({}, n, {
                element: e,
                active: !0
            });
            return function(e) {
                e.originalStyle = {
                    whiteSpace: e.element.style.whiteSpace,
                    display: e.element.style.display,
                    fontSize: e.element.style.fontSize
                }, F(e), e.newbie = !0, e.dirty = !0, a.push(e);
            }(t), {
                element: e,
                fit: h(t, o),
                unfreeze: b(t),
                freeze: z(t),
                unsubscribe: w(t)
            };
        });
        return u(), i;
    }
    function x(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return "string" == typeof e ? C(t(document.querySelectorAll(e)), n) : C([
            e
        ], n)[0];
    }
}("undefined" == typeof window ? null : window);
var $7197710c1f2e2b92$export$2e2bcd8739ae039 = $7197710c1f2e2b92$var$e;


document.documentElement.classList.add("js");
function $dad545c909cfec2d$var$ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}
$dad545c909cfec2d$var$ready(function() {
    (0, $7197710c1f2e2b92$export$2e2bcd8739ae039)(".fit");
});


//# sourceMappingURL=index.763e28ba.js.map
